import React from 'react';
import I18n from 'i18n-js';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import { Menu } from '@/components/common/LessonPlanning';
import menuStyles from '@/components/common/LessonPlanning/LessonPlanning.module.scss';

interface SlideTypeToggleProps {
  hasArchivedContent?: boolean;
  hideTabs: boolean;
  setSelected: React.Dispatch<React.SetStateAction<string | number>>
  toggleShowArchived?: () => void;
}

const SlideTypeToggle = ({
  hasArchivedContent = false,
  hideTabs,
  setSelected,
  toggleShowArchived = () => {
  },
}: SlideTypeToggleProps) => (
  <div>
    {!hideTabs && (
      <div className="tw-relative">
        <ScrollMenu
          hideArrows
          hideSingleArrow
          alignCenter={false}
          data={Menu(
            [
              { id: 0, title: I18n.t('tci_content') },
              { id: 1, title: I18n.t('my_slideshows') },
            ],
            'resource-0',
          )}
          dragging={false}
          itemClass={menuStyles.itemWrapper}
          menuClass={menuStyles.horizontalMenu}
          selected="resource-0"
          useButtonRole={false}
          wheel={false}
          onSelect={setSelected}
        />
        {hasArchivedContent && (
          <span className="tw-absolute tw-top-0 tw-right-0">
            <label className="tw-mt-3" htmlFor="show_archived_content">
              <input
                className="tw-mr-2"
                id="show_archived_content"
                name="show_archived_content"
                type="checkbox"
                onChange={toggleShowArchived}
              />

              {I18n.t('show_archived_content')}
            </label>
          </span>
        )}
      </div>
    )}
  </div>
);

export default SlideTypeToggle;
